import { Button, IconChevronUp16 } from '@cian/ui-kit';
import * as React from 'react';
import { smoothScrollToPosition } from '../../utils/scroll';
import { useEventCallback } from '@cian/react-utils';
import { useDispatch, useSelector } from 'react-redux';
import { TThunkDispatch } from '../../types/redux';
import { selectIsMoreButtonShown } from '../../selectors/pagination';
import { ActionButtons } from '../../components/ActionButtons';
import { loadBuildersProjectsData } from '../../actions/buildersProjects/loadBuildersProjects';
import { selectProjectsList, selectStatus } from '../../selectors/projects';
import { EBuildersProjectsDataStatus } from '../../types/buildersProjects';

export const ActionButtonsContainer: React.FC = () => {
  const dispatch = useDispatch<TThunkDispatch>();

  const showMoreButton = useSelector(selectIsMoreButtonShown);
  const status = useSelector(selectStatus);
  const projectsList = useSelector(selectProjectsList);

  const handleScrollToTop = useEventCallback(() => {
    smoothScrollToPosition(0);
  });

  const handleShowMoreClick = useEventCallback(() => {
    dispatch(loadBuildersProjectsData());
  });

  if (!projectsList.length) {
    return null;
  }

  return (
    <ActionButtons>
      {showMoreButton && (
        <Button
          onClick={handleShowMoreClick}
          size="L"
          fullWidth
          loading={status === EBuildersProjectsDataStatus.Fetching}
        >
          Показать ещё
        </Button>
      )}
      <Button
        beforeIcon={<IconChevronUp16 color="primary_100" />}
        onClick={handleScrollToTop}
        size="L"
        theme="fill_secondary"
        fullWidth
      >
        {!showMoreButton ? 'Наверх' : ''}
      </Button>
    </ActionButtons>
  );
};
